/**
 * 加载中组件
 */
import React from 'react';
import {Spin} from 'antd';
import LoadingIcon from '@/assets/loading.svg?react';
// import {LoadingOutlined} from '@ant-design/icons';
// import styles from './index.module.less';
import './index.global.less';

interface CompSpinProps {
    delay?: number;
    children?: React.ReactNode;
    spinColor?: string;
    width?: number;
    spinning?: boolean;
}

const CompSpin: React.FC<CompSpinProps> = ({
    children,
    width = 50,
    ...rest
}) => {
    const CustomLoadingIcon = () => (
        <LoadingIcon
            className={'afd-loading-svg'}
            style={{
                width: width,
                height: width,
            }}
        />
    );

    return (
        <Spin
            {...rest}
            indicator={<CustomLoadingIcon />}
        >
            {children}
        </Spin>
    );
};

export default CompSpin;
